import { useState, useEffect } from 'react';
import { supabase } from '../client/client';
import './EquipmentForm.css';
import Layout from './Layout';
import Loading from './Loading';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../context/LoginContext';

const UserForm = () => {
    const navigate = useNavigate();
    const { getSessionAuth } = useLogin();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const init = async () => {
            const session = await getSessionAuth();
            if (!session) { navigate("/", { replace: true }); return; }
            setLoading(false);
        };
        init();
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        role: '',
        charge: '',
    });

    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const roleOptions = [
        'client',
        'admin',
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = name === 'name' ? value.toUpperCase() : value;

        setFormData((prevData) => ({
            ...prevData,
            [name]: formattedValue,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const { data: userAuth, error } = await supabase.auth.signUp({
            email: formData.email,
            password: formData.password,
        });

        if (error) {
            setError('Error al registrar usuario: ' + error.message);
            return;
        }

        if (userAuth) {
            const now = new Date().toISOString();
            const { error: dbError } = await supabase.from('users').upsert([
                {
                    id: userAuth.user.id,
                    updated_at: now,
                    name:     formData.name,
                    email:    formData.email,
                    role:     formData.role,
                    charge:   formData.charge,
                },
            ]);

            if (dbError) {
                setError('Error al guardar en la base de datos: ' + dbError.message);
            } else {
                setShowSuccessDialog(true);
            }
        }

    };

    const handleAccept = () => {
        setShowSuccessDialog(false);
        navigate("/usuarios");
    };

    const sortedRoleOptions = roleOptions.slice().sort();

    return (
        <Layout>
            {loading && <Loading />}
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 text-sm">
                    {error}
                </div>
            )}
            <div className="mb-8">
                <h1 className="text-[#4691A6] font-bold text-3xl">CREAR USUARIO</h1>
            </div>
            <form className="equipment-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Nombre:
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Email:
                            <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Contraseña:
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                        </label>
                    </div>

                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Cargo:
                            <input
                                type="text"
                                name="charge"
                                value={formData.charge}
                                onChange={handleChange}
                                placeholder="Ej: Árbitro, Contador..."
                            />
                        </label>
                    </div>

                    <div className="field">
                        <label className='text-xs font-semibold'>
                            Rol:
                            <div className="styled-select">
                                <select
                                    name="role"
                                    value={formData.role}
                                    onChange={handleChange}
                                    className="styled-select"
                                >
                                    <option value="">Selecciona una opción</option>
                                    {sortedRoleOptions.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </label>
                    </div>

                </div>



                <div className="form-row">
                    <button className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md " type="submit">Guardar</button>
                </div>

                {showSuccessDialog && (
                    <div className="success-dialog">
                        <p>Se ha guardado exitosamente</p>
                        <button onClick={handleAccept} className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-300 text-base cursor-pointer mt-7 text-white font-semibold py-2 px-4 rounded-md w-full">Aceptar</button>
                    </div>
                )}
            </form>
        </Layout>
    );
};

export default UserForm;
